// ──────────────────────────────────────
// CREATE PROJECT RESPONSE MAPPER
// ──────────────────────────────────────

import { ProjectCreationApiResponseData } from '../../interfaces/api/responses/saveProject.response';

import { IqeProject } from '../../interfaces/ui';
import { ProjectFormData } from '../../interfaces/ui/addProjectModal';
import { toUiProjectStatus } from '../sharedDto/status.dto';
import {
  buildWriteTestPlan,
  buildReadTestPlan,
} from '../sharedDto/testPlan.dto';
import { toSystemValue } from '../../utils';

export function mapSaveProjectResponse(
  formData: ProjectFormData,
  responseData: ProjectCreationApiResponseData,
): IqeProject {
  const newProjectId = responseData.projectId;
  const createdDate = responseData.createdAt
    ? new Date(responseData.createdAt)
    : new Date();
  const system = toSystemValue(formData.projectMappingType);

  const newIqeProject: IqeProject = {
    id: newProjectId,
    name: formData.projectName,
    appUrl: formData.appUrl,
    loginNotRequired: formData.loginNotRequired,
    environment: formData.environment,
    projectMappingType: formData.projectMappingType,
    operation: responseData.operation ?? '',
    msProjectId: responseData.msProjectId ?? '',
    writeTestPlan: buildWriteTestPlan(
      system,
      formData.mappedProjectId,
      formData.mappedProjectName,
      formData.mappedProjectOrg,
      formData.testPlanId,
      formData.testPlanName,
      formData.testSuiteId,
      formData.testSuiteName,
    ),
    readTestPlan: buildReadTestPlan(
      system,
      formData.mappedProjectId,
      formData.mappedProjectName,
      formData.mappedProjectOrg,
      formData.existingTestPlanId,
      formData.existingTestPlanName,
      formData.existingTestSuiteId,
      formData.existingTestSuiteName,
    ),
    flowId: formData.flowId,
    flowName: formData.flowName,
    repositoryConfig: formData.repositoryConfig,
    frontendRepositoryName: formData.frontendRepositoryName,
    frontendRepositoryUrl: formData.frontendRepositoryUrl,
    frontendRepositoryBranch: formData.frontendRepositoryBranch,
    playwrightTestRepositoryUrl: formData.playwrightTestRepositoryUrl,
    transactionId: responseData.transactionId,
    createdAt: createdDate,
    status: toUiProjectStatus(responseData.status),
    runs: [],
  };
  return newIqeProject;
}
